import { Tooltip } from "antd";
import styles from "./taskMessage.module.scss";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import ChatTaskInner from "../chatTaskInner";
import React, { useEffect } from "react";
import moment from "moment";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
import ChatLike from "../chatLike";
import { chats, initialStateModel } from "../../../../models/model";
import { useSelector } from "react-redux";

type taskMessageProps = {
  data: any;
  searchedData?: any;
  viewData?: any;
  savedData?: any;
  timeValue?: any;
};
export default function ChatTaskMessage({ data, searchedData, viewData, savedData,timeValue }: taskMessageProps) {
  let { direction, timestamp, fromcaller_details, id } = data;
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let timeCount = timeValue !== undefined ? timeValue : 18;
  useEffect(() => {
    var focusableInputElements: any = document.querySelectorAll(".focusText");
    if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
      focusableInputElements[0].focus();
    }
  }, [savedData]);
  try {
    let htimestamp = moment(timestamp).format("hh:mm A");
    let taskData: any = "";
    if (data.message?.body) {
      taskData = data.message?.body;
    }

    const handlehighlightHover = () => {
      var element: HTMLElement | any = document.getElementById(id) || null;
      if (element != null) {
        element.classList.add("highlighthover");
      }
    };

    return (
      <>
        {/* <div className={`${styles.chatMsg} ${styles.leftMessage} ${styles.addBookleftMessage}`}> */}
        {direction === 'IN' ? <div className={`${chatReducer.isSaveChat && id === savedData ? 'savedhighlight' : ''
          } lftMessage ${styles.chatMsg} ${styles.leftMessage}`} id={id}>
        {timeCount > 15 &&  <div className={`${styles.chatUserDetails}`}>
            <ChatUserInfo userDetails={fromcaller_details} className='userinfoIcon leftSide' />
            
            <div className={styles.convMemName}><span>{fromcaller_details?.caller_id}</span></div>
          </div>}
          <div className={styles.chatLeftMessages}>
            <div className={styles.chatLeft}>
              <Tooltip mouseEnterDelay={0.5} title={htimestamp} className='cusTooltip'
                overlayClassName='customTooltip'><div className={styles.chatTime}>{htimestamp}</div></Tooltip>
              <div className={`msgContentLft ${styles.chatContent}`}>
                <span className={id === savedData ? "focusText" : ""} tabIndex={0}>
                  <div className={styles.leftTaskBox}>
                    <ChatTaskInner taskData={taskData} searchedData={searchedData} viewData={viewData} />
                    <div className={styles.taskDscription}>{taskData.description}</div>
                  </div>
                </span>
                <span className={styles.TasksChatContent}> {data?.message?.isEdit ? " Updated the task" : "Created a new Task"} </span>
                <ChatLeftInfo userDetails={fromcaller_details} timeStamp={timestamp} message={data}></ChatLeftInfo>
                <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}><ChatHoverOption className='hoverList hoverListleft' data={data} highlightHover={handlehighlightHover} /></div>
              </div>
            </div>
          </div>
          <ChatLike className="likeLeft" placement="top" tooltipTitle={data?.likeduserdetails} message={data} />

          </div>
         : (
          <div
            className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} rtMessage ${styles.chatMsg} ${
              styles.rightMessage
            }`}
            id={id}
          >
           {timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
              <div className={styles.convMemName}>
                <span>You</span>
              </div>
              <ChatUserInfo userDetails={fromcaller_details} className="userinfoIcon rightSide" />
            </div>}
            <div className={styles.chatRightMessages}>
              <div className={styles.chatRight}>
                <div className={`msgContentRT ${styles.chatContent}`}>
                  <span className={id === savedData ? "focusText" : ""} tabIndex={0}>
                    <div className={styles.rightTaskBox}>
                      <ChatTaskInner taskData={taskData} searchedData={searchedData} viewData={viewData} />
                      <div className={styles.taskDscription}>{taskData.description}</div>
                    </div>
                  </span>
                  <span className={styles.TasksChatContent}>
                    {data?.message?.isEdit ? "You updated the Task" : "You created a new Task"}
                  </span>
                  <ChatRightInfo userDetails={fromcaller_details} timeStamp={timestamp} message={data}></ChatRightInfo>
                  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption
                      className="hoverList hoverListright"
                      data={data}
                      highlightHover={handlehighlightHover}
                    />
                  </div>
                </div>
                <Tooltip
                  mouseEnterDelay={0.5}
                  placement="topRight"
                  title={htimestamp}
                  className="cusTooltip"
                  overlayClassName="customTooltip"
                >
                  <div className={styles.chatTime}>{htimestamp}</div>
                </Tooltip>
              </div>
              <ChatLike
                className="likeRight"
                placement="topRight"
                tooltipTitle={data?.likeduserdetails}
                message={data}
              />
            </div>
            {/* <URCheckBox className="chatSelectRight"/> */}
          </div>
        )}

        {/* <div className={`${styles.chatMsg} ${styles.rightMessage}`}>
        <div className={styles.chatRightMessages}>
          <div className={styles.chatRight}>
            <div className={styles.chatContent}>
              <ChatTaskInner className='taskRight' />
            </div>
            <Tooltip placement="topRight" title='Today at 12:13 PM'
              className='cusTooltip' overlayClassName='customTooltip'>
              <div className={styles.chatTime}>12:13</div></Tooltip>
          </div>
        </div>
        <URCheckBox className="chatSelectRight" />
        <div className={styles.hoverOptions}><ChatHoverOption className='hoverList hoverListright' /></div>
      </div> */}
      </>
    );
  } catch (e) {
    return <p style={{ color: "red" }}>Something went wrong</p>;
  }
}
